__turbopack_context__.v({
  "accordionSlideOverwrite": "termSheetSelect-module-scss-module__Djoe4q__accordionSlideOverwrite",
  "fadeIn": "termSheetSelect-module-scss-module__Djoe4q__fadeIn",
  "fadeOut": "termSheetSelect-module-scss-module__Djoe4q__fadeOut",
  "field": "termSheetSelect-module-scss-module__Djoe4q__field",
  "heading": "termSheetSelect-module-scss-module__Djoe4q__heading",
  "label": "termSheetSelect-module-scss-module__Djoe4q__label",
  "scaleIn": "termSheetSelect-module-scss-module__Djoe4q__scaleIn",
  "scaleOut": "termSheetSelect-module-scss-module__Djoe4q__scaleOut",
  "zoomIn": "termSheetSelect-module-scss-module__Djoe4q__zoomIn",
  "zoomOut": "termSheetSelect-module-scss-module__Djoe4q__zoomOut",
});
